import React from 'react'

import { ListItemGeneral } from '@interco/inter-toranja'
import { useActionHandler } from '@/hooks/useActionHandler'
import { useHomeCreditListItemTag } from '@/hooks/useHomeCreditListItemTag'

import * as S from './styles'

interface ListItemGeneralSDUIProps {
  items: ListItemGeneralData[]
  style?: { marginTop?: string; marginBottom?: string }
  componentAnalytics?: Analytics
}

const mapTrailingProps = (item: ListItemGeneralData) => {
  const trailingType = item.trailingType ?? 'tagChevron'
  const trailingProps = item.trailingProps ?? {}

  if (trailingType === 'tagChevron') {
    return {
      type: 'tagChevron' as const,
      tagChevronProps: {
        showTag: trailingProps.showTag ?? Boolean(trailingProps.tagLabel),
        tagLabel: trailingProps.tagLabel,
        tagColor: (trailingProps.tagColor as 'brand') ?? 'brand',
      },
    }
  }

  if (trailingType === 'badge') {
    return {
      type: 'badge' as const,
      badgeProps: {
        showBadge: trailingProps.showBadge ?? true,
        badgeValue: trailingProps.badgeValue,
        showDate: false,
        date: undefined,
      },
    }
  }

  if (trailingType === 'text') {
    return {
      type: 'text' as const,
      textProps: {
        labelTrailing: trailingProps.labelTrailing ?? '',
        labelTrailingColor: trailingProps.labelTrailingColor ?? 'neutral',
        paragraphTrailing: trailingProps.paragraphTrailing,
      },
    }
  }

  return {
    type: 'tagChevron' as const,
    tagChevronProps: {
      showTag: false,
      tagLabel: 'Label',
      tagColor: 'brand',
    },
  }
}

export const ListItemGeneralSDUI: React.FC<ListItemGeneralSDUIProps> = ({
  items,
  style,
  componentAnalytics,
}) => {
  const { dispatchAction } = useActionHandler()
  const fireListItemTag = useHomeCreditListItemTag()

  return (
    <S.ContainerListItemDefault style={style}>
      {items.map((item) => (
        <ListItemGeneral
          key={item.id}
          label={item.title}
          paragraph={item.description}
          showDivider={item.showDivider === 'enabled'}
          variant={(item.variant as 'inset') ?? 'inset'}
          leadingProps={
            item.showLeading !== 'disabled' && item.icon
              ? {
                  iconProps: {
                    asset: item.icon as never,
                    color: 'Icon/Neutral/Primary',
                    contentDescription: 'Icon',
                    size: 'medium',
                  },
                  type: 'icon',
                }
              : undefined
          }
          trailingProps={
            mapTrailingProps(item) as React.ComponentProps<typeof ListItemGeneral>['trailingProps']
          }
          onTag={(tag) => fireListItemTag(tag, item.title)}
          onClick={() => dispatchAction(item.action, item.analytics ?? componentAnalytics)}
        />
      ))}
    </S.ContainerListItemDefault>
  )
}
